/**
 * Component: Bundle tracker
 *
 * @namespace bundleTracker
 */

/**
 * DOM selectors
 */
const bundleSelectors = {
  container: '[js-bundle-tracker="container"]',
  prevButton: '[js-bundle-tracker="prev"]',
  nextButton: '[js-bundle-tracker="next"]',
  scrollbar: '[js-bundle-tracker="scrollbar"]',
  hideDetails: '[js-bundle-tracker="hide-details"]',
  bundleTitle: '[js-bundle-drawer="bundle-title"]',
  detailsLabel: '[js-bundle-tracker="hide-details-label"]'
};

document.addEventListener('DOMContentLoaded', () => {
  const initializeBundleSlider = () => {
    if (typeof Swiper !== 'undefined') {
      new Swiper(document.querySelector(bundleSelectors.container), {
        spaceBetween: 20,
        slidesPerView: 8,
        setWrapperSize: true,
        navigation: {
          nextEl: bundleSelectors.nextButton,
          prevEl: bundleSelectors.prevButton
        },
        scrollbar: {
          enabled: false
        },
        breakpoints: {
          990: {
            spaceBetween: 5,
            slidesPerView: 5,
            navigation: false,
            scrollbar: {
              enabled: true,
              el: bundleSelectors.scrollbar,
              hide: false
            }
          }
        }
      });

      document.querySelector(bundleSelectors.hideDetails).addEventListener('click', () => {
        document.querySelectorAll(`${bundleSelectors.hideDetails} ${bundleSelectors.detailsLabel}`).forEach((span) => {
          span.classList.toggle('hidden');
        });
        document.querySelectorAll(bundleSelectors.bundleTitle).forEach((element) => {
          element.classList.toggle('hidden');
        });
      });
    } else {
      setTimeout(initializeBundleSlider, 100);
    }
  };

  initializeBundleSlider();
});
